import React, { useEffect, useState } from 'react'
import './search-customer.scss'
import SinglePage from '../../components/common/page/SinglePage'
import NormalInput from '../../components/common/inputs/NormalInput'
import SelectInput from '../../components/common/inputs/SelectInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { customerAxios } from '../../config/axios'
import { toast } from 'react-hot-toast'
import Spinner from '../../components/common/spinners/SpinWithMessage'
import { FcSearch } from "react-icons/fc";
import { FcDeleteDatabase } from "react-icons/fc";
import { NavLink, useNavigate } from 'react-router-dom'
import { FaStar } from 'react-icons/fa'
import InfoBox from '../../components/common/info-box/InfoBox'
import { FiEdit2 } from "react-icons/fi";
import { useSelector } from 'react-redux'



const SearchCustomer = () => {
    const [form, setForm] = useState({
        search: '',
    })
    const [loading, setLoading] = useState('')
    const [data, setData] = useState([])
    const [cities, setCities] = useState([])
    const [postList, setPostList] = useState([])
    const [ifSearch, setIfSearch] = useState(false)
    const navigate = useNavigate()
    const { user } = useSelector((state) => state.userAuth)
   

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })

        if (e.target.name === 'city_id') {
            const posts = cities?.filter((city) => city?.value === e.target.value)?.[0]?.post_list || []
            setPostList(posts?.map((post) => ({ option: post, value: post })))
        }
    }
  

    const handleApply = (e) => {
        e.preventDefault();

        if (form.search && form.search.length < 3) {
            toast.error('Enter at least 3 characters')
            return;
        }

        if (!form?.search && !form?.city_id) {
            toast.error('Select any filter field')
            return;
        }

        setLoading('filter')
        customerAxios.get(`/search?search_key=${form.search}&city_id=${form?.city_id || ''}&post=${form?.post || ''}`)
            .then((response) => {
                setIfSearch(true)
                setData(response.data)
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }


    useEffect(() => {
        customerAxios.get('/l/area').then((response) => {
            const cityData = response.data?.map((city) => ({ option: city?.city_name, value: city?.city_id, post_list: city?.post_offices }))
            setCities([...cityData, { option: 'No City Customer', value: 'unknown' }])
        }).catch((error) => {
            toast.error(error?.message)
        })
    }, [])


    return (
        <div className="search-customer-div">
            <SinglePage titleArray={['Search customer']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <form action="" onSubmit={handleApply}>
                            <div className="search-section">
                                <h5>Search</h5>
                                <InfoBox description={'Your can search CID, Name, Address, Place, Pin and Contacts '} />
                                <NormalInput label='Enter at least 3 characters' name='search' value={form.search} onChangeFun={handleChange} isRequired={false} />
                                <SelectInput label={'City'} name={'city_id'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={cities} />
                                {postList?.[0] && <SelectInput label={'Post office'} name={'post'} isRequired={false} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={postList || []} />}
                            </div>
                           
                            {((form?.search && form?.search?.length > 2) || form?.city_id || form?.products?.[0] || form?.flt_type) &&
                                <div className="button-div">
                                    <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                                </div>}
                        </form>
                    </div>
                    <div className="result-div">
                      
                        <div className="header-div">
                            {ifSearch ? <h4>{data?.length || '0'} {data?.length > 1 ? 'Results' : 'Result'}</h4>
                                : <h4>Find Customers</h4>
                            }
                        </div>
                        <div className="items-div">
                            {data?.[0] ?
                                <>
                                    {data.map((customer, index) => <div className="profile-div" key={index}>
                                        <NavLink to={`/customer/${customer.customer_id}/full-view`}>
                                            <div className="profile-image-div">
                                                <h3>{customer.customer_name?.slice(0, 1).toUpperCase()}</h3>
                                                {/* <span className='text-badge green-text'><FaStar /> {customer?.star_rate || 0}</span> */}
                                            </div>
                                            <p>CID : {customer.customer_id}</p>
                                            <h4>{customer.customer_name}</h4>
                                            <p>{customer?.address?.address}, {customer?.address?.place}, {customer?.address?.post} P.O, </p>
                                            <p>{customer?.address?.city_name} - {customer?.address?.pin_code}</p>
                                           
                                        </NavLink>
                                        {user?.designation?.allow_origins?.includes('ControlNex') &&
                                            <div className="hover-view-div">
                                                <div className="icon-with-action-div" onClick={() => navigate(`/customer/${customer.customer_id}/edit`)}>
                                                    <FiEdit2 />
                                                </div>
                                            </div>}
                                    </div>)}

                                </>
                                : <>
                                    <Spinner height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search customer'}
                                        icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                                </>}
                        </div>
                      
                    </div>
                </div>
            </SinglePage>
        </div>
    )
}

export default SearchCustomer